import { render, staticRenderFns } from "./FAQ.Detail.vue?vue&type=template&id=395c6424&"
import script from "./FAQ.Detail.vue?vue&type=script&lang=js&"
export * from "./FAQ.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports